import { cva } from 'class-variance-authority';

/**
 * The chip class recipe, in its own module so pages can style a bare
 * button as a chip without importing the ChipSelector component. Keeping
 * it beside the component instead broke react-refresh: a file that
 * exports both a component and a constant cannot be hot-swapped.
 */
export const chipVariants = cva(
  'cr-flex cr-items-center cr-justify-center cr-whitespace-nowrap cr-px-4 cr-py-2 cr-rounded-lg cr-cursor-pointer cr-transition-colors cr-duration-200 cr-text-sm',
  {
    variants: {
      active: {
        true: 'cr-bg-cirrusBlue-35 cr-text-blue-900 hover:cr-bg-cirrusBlue-100',
        false: 'cr-bg-gray-100 cr-text-blue-900 cr-border-2 cr-border-blue-900 hover:cr-bg-gray-300',
      },
    },
    defaultVariants: {
      active: false,
    },
  }
);
